<template>
  <div class="table">
    <div class="commonSearch" ref="commonSearchRef">
      <el-form class="el-form el-form--inline" onsubmit="return false">
        <el-form-item>
          <el-date-picker
            v-model="startDate"
            align="right"
            type="datetime"
            placeholder="请选择开始时间"
            @change="getSelectedTime"
            :style="{width:'auto'}"
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="endDate"
            align="right"
            type="datetime"
            placeholder="请选择结束时间"
            @change="getSelectedTime"
            :style="{width:'auto'}"
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="业务分类">
          <el-select v-model="systemId" placeholder="请选择业务分类" clearable @change="changeSystem">
            <el-option
              v-for="item in systemIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日志模块">
          <el-select v-model="moduleName" placeholder="请选择日志模块" clearable @change="changePlatform">
            <el-option
              v-for="item in moduleNameList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源">
          <el-select v-model="operSource" placeholder="请选择系统" clearable @change="changePlatform">
            <el-option
              v-for="item in operSourceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="info" plain icon="el-icon-search" @click="refreshData">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="clear:both"></div>
    </div>
    <div class="commonOperBtn" ref="commonOperBtnRef">
      <el-button type="primary" plain @click="changeType('1')">系统</el-button>
      <el-button type="danger" plain @click="changeType('2')">业务</el-button>
    </div>
    <div class="commonTable">
      <el-table
        :data="returnData"
        style="width: 100%"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        @select="handleSelect"
        @select-all="handleSelection"
        v-loading="loading"
        element-loading-text="拼命加载中"
        size="medium"
        :height="tabHeight"
      >
        <el-table-column prop="operUserName" label="操作用户" align="left" min-width="100"></el-table-column>
        <el-table-column prop="systemName" label="所属分类" align="left" min-width="120"></el-table-column>
        <el-table-column prop="moduleName" label="日志模块" align="left" min-width="100"></el-table-column>
        <el-table-column prop="contents" label="日志内容" align="left" min-width="240"></el-table-column>
        <el-table-column prop="operIp" label="IP" min-width="80" align="left"></el-table-column>
        <el-table-column prop="createAt" label="时间" min-width="150" align="left"></el-table-column>
        <el-table-column label="来源" width="100" align="left">
          <template slot-scope="scope">
            <span
              v-if="scope.row.operSource=='pc'"
              type="primary"
              class="fa fa-tv fa-2x btnColor"
              font-size="10px"
            ></span>
            <span
              v-if="scope.row.operSource=='mobile'"
              type="primary"
              class="fa fa-tablet fa-2x btnColor"
              font-size="10px"
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页框 -->
    <div class="commonPage">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[5, 10, 15, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :disabled="loading"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [TabResize],
  components: {},
  mounted: function() {
    //初始化
    this.per_page = this.$constant.PAGE_SIZE;
    this.logType = "1";
    this.initData();
    this.initModuleList(this.systemId);
    this.loadSystems();
  },
  data() {
    return {
      operSource: "",
      operSourceList: [
        {
          value: "pc",
          label: "pc"
        },
        {
          value: "mobile",
          label: "mobile"
        }
      ],
      systemId: this.$constant.CATALOG,
      systemIdList: [],
      moduleName: "",
      moduleNameList: [],
      startDate: "",
      endDate: "",
      logType: "",
      platformType: "",
      loading: true,
      returnData: [],
      cur_page: 1,
      cacheData: {},
      multipleSelection: [],
      select_word: "",
      totalCount: 0,
      per_page: "",
      rules: {
        call_type: [
          { required: true, message: "请选择呼叫类型", trigger: "blur" }
        ]
      }
    };
  },
  watch: {},
  methods: {
    initData() {
      let param = {
        pageNum: this.cur_page,
        pageSize: this.per_page,
        startDate: this.startDate,
        endDate: this.endDate,
        systemId: this.systemId,
        moduleName: this.moduleName,
        operSource: this.operSource,
        logType: this.logType
      };
      SettingApi.getClass()
        .getLogsListData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.totalCount = res2.data.data.totalElements;
            this.returnData = res2.data.data.data;
            this.loading = false;
          } else {
            this.$message.error(res2.data.msg);
            this.loading = false;
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    //获取选中行
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelect(selection, row) {
      this.cacheData[this.cur_page] = selection;
    },
    handleSelection(selection) {
      this.cacheData[this.cur_page] = selection;
    },
    initSelect() {
      for (let prop in this.cacheData) {
        if (prop == this.cur_page) {
          if (this.cacheData[prop] && this.cacheData[prop].length > 0) {
            this.$nextTick(() => {
              this.checkIsSelected(this.cacheData[prop]);
            });
          }
        }
      }
    },
    checkIsSelected(selectedData) {
      this.returnData.forEach(element => {
        selectedData.forEach(el => {
          if (el.id == element.id) {
            this.$refs.multipleTable.toggleRowSelection(element, true);
          }
        });
      });
    },
    // 分页导航
    handleCurrentChange(val) {
      this.cur_page = val;
    },
    //切换每页显示多条
    handleSizeChange(val) {
      this.per_page = val;
      this.cur_page = 1;
      this.loading = true;
      this.initData();
    },
    // 切换显示第几页
    handleCurrentChange(val) {
      this.cur_page = val;
      this.loading = true;
      this.initData();
    },
    refreshData() {
      this.cur_page = 1;
      this.initData();
    },
    getSelectedTime() {
      this.initData();
    },
    //删除用户
    deleteData() {
      let idList = new Array();
      if (this.multipleSelection.length == 0) {
        this.$message.error("请至少选择一条要删除的数据！");
        return false;
      }
      //遍历选中的checkbox数据集合 拿出其中的ids
      for (let i = 0; i < this.multipleSelection.length; i++) {
        idList[i] = "" + this.multipleSelection[i]["id"];
      }
      let param = {
        ids: idList
      };
      this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          SettingApi.getClass()
            .deleteRoleById(param)
            .then(res2 => {
              if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                this.$message.success("删除成功！");
                this.loading = false;
                this.initData();
              } else {
                this.$message.error(res2.data.msg);
                this.loading = false;
                return false;
              }
            })
            .catch(err => {
              this.$message.error(err);
              this.loading = false;
              return false;
            });
        })
        .catch(() => {});
    },
    changePlatform() {
      this.cur_page = 1;
      this.initData();
    },
    changeSystem() {
      this.cur_page = 1;
      this.initData();
      this.initModuleList(this.systemId);
    },
    initModuleList(systemId) {
      this.$mhttp;
      SettingApi.getClass()
        .getAllMenus(systemId)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            this.moduleNameList = [];
            // alert(data.length);
            for (let i = 0; i < data.length; i++) {
              if (data[i].level != "1" && data[i].name != "日志管理") {
                let obj = {
                  value: data[i].id,
                  label: data[i].name
                };
                this.moduleNameList.push(obj);
              }
            }
            let otherData = ["通用文件", "登录"];
            for (let j = 0; j < otherData.length; j++) {
              let otherObj = {
                value: otherData[j],
                label: otherData[j]
              };
              this.moduleNameList.push(otherObj);
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },

    loadSystems() {
      SettingApi.getClass()
        .loadSystems()
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            this.systemIdList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    changeType(val) {
      if (val == "1") {
        this.logType = 1;
      } else {
        this.logType = 2;
      }
      this.initData();
    }
  }
};
</script>

<style lang="stylus" scoped>
.head-right {
  float: right;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.btnColor {
  color: $theme-color;
}
</style>
